// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__15SXk","h_footer":"footer_h_footer__1Z4S-","span_footer":"footer_span_footer__3oB3c"};